import $ from "jquery";
import Promise = JQuery.Promise;

export interface AjaxFormDataOptions {
    url?: string;
    method?: 'post' | 'POST';
    data?: {},
    headers?: {},
    success?: (data: any, textStatus: string, jqXHR: JQueryXHR) => void;
    error?: (jqXHR: JQueryXHR) => void;
}

export default class AjaxFormData {
    utf8encode: Function;

    constructor() {
        this.utf8encode = typeof (TextEncoder) != 'undefined'
            ? function (str: string) {
                let encoder = new TextEncoder();
                let bytes = encoder.encode(str);
                let result = '';
                for (let i = 0; i < bytes.length; ++i)
                    result += String.fromCharCode(bytes[i]);
                return result;
            }
            : function (str: string) {
                return eval('\'' + encodeURI(str).replace(/%/gm, '\\x') + '\'');
            }
    }

    makeBoundary() {
        return '----JQBoundary' + btoa(Math.random().toString()).substr(0, 12);
    }

    str2Uint8Array(str: string): Uint8Array {
        let arr = [], c;
        for (let i = 0; i < str.length; ++i) {
            c = str.charCodeAt(i);
            if (c > 0xff) {
                alert('Char code range out of 8 bit, parse error!');
                return new Uint8Array();
            }
            arr.push(str.charCodeAt(i));
        }
        return new Uint8Array(arr);
    }

    create(url: string, options: AjaxFormDataOptions) {
        // Compatible arguments when url is not given.
        if (typeof url == 'object') {
            options = url;
            url = undefined;
        }
        options = options || {};
        options.url = options.url || url || '';
        options.method = options.method || 'post';  // post method default

        // Create the final options object
        let s = jQuery.ajaxSetup(options);

        // Bypassing http safe methods.
        if (typeof (s.data) !== 'object' ||
            !/^(GET|HEAD|OPTIONS|TRACE)$/.test(s.type)) {
            return $.ajax(s);
        }

        let data = s.data;
        let boundary = this.makeBoundary();
        let promises: Array<Promise<any, any, any>> = [];
        let postdata = '';

        /**
         * Serialize a single field, and export to formdata.
         * If async load is required, add promise to queue.
         * @param name: field key
         * @param val {string|number|boolean|File|Blob}: field content
         * @returns string: a boundary divided form-data part as a string.
         */
        const appendField = (name: string, val: File | string | number) => {
            // Supports File or Blob objects
            if (val instanceof File) {
                promises.push($.Deferred((dfd) => {
                    let reader = new FileReader();
                    reader.onload = (e) => {
                        let bin_val = e.target.result;
                        let filename = val.name && this.utf8encode(val.name) || 'blob';
                        let content_type = val.type || 'application/octet-stream';
                        postdata += '--' + boundary + '\r\n' +
                            'Content-Disposition: form-data; ' +
                            'name="' + name + '"; filename="' + filename + '"\r\n' +
                            'Content-Type: ' + content_type + '\r\n\r\n' +
                            bin_val + '\r\n';
                        dfd.resolve();
                    };
                    reader.readAsBinaryString(val);
                }).promise());
            }
            // Supports normal base64 image types
            else if (typeof (val) == 'string' && /^data:image\/\w+;base64,/.test(val)) {
                // data:image/????;base64,xxxxx
                let pos = val.search(';base64,');
                let content_type = val.substr(5, pos - 5);
                let bin_val = atob(val.substr(pos + 8));
                postdata += '--' + boundary + '\r\n' +
                    'Content-Disposition: form-data; ' +
                    'name="' + name + '"; filename="blob"\r\n' +
                    'Content-Type: ' + content_type + '\r\n\r\n' +
                    bin_val + '\r\n';
            }
            // Supports normal string support
            else if (typeof (val) == 'string' || typeof (val) == 'number') {
                // encode unicode characters to utf8 bytes
                postdata += '--' + boundary + '\r\n' +
                    'Content-Disposition: form-data; ' +
                    'name="' + name + '"\r\n\r\n' +
                    this.utf8encode(val.toString()) + '\r\n';
            }
            // Like a single checkbox, true posts an 'on' value, omit false.
            else if (typeof (val) === 'boolean') {
                // Only true value is export as 'on', false is omitted.
                if (val) {
                    postdata += '--' + boundary + '\r\n' +
                        'Content-Disposition: form-data; ' +
                        'name="' + name + '"\r\n\r\n' +
                        'on' + '\r\n';
                }
            }
            // Not supporting case.
            else {
                alert(
                    'jQuery.formdata: Post field type not supported,\n' +
                    'ignore the field [' + name + '].'
                );
            }

        };

        // Deal with all the fields in the data dict.
        $.each(data, function (name: string, val: Array<any> | FileList) {

            // Deal with multiple fields
            // Like a multiple checkbox, an array yield multiple parts.
            if (val instanceof Array || val instanceof FileList) {
                if (/\[]$/.test(name)) {
                    $.each(val, function () {
                        appendField(name, this);
                    });
                } else {
                    alert(
                        'jQuery.formdata: an array field must have a `[]` suffix.\n' +
                        'ignore the field [' + name + '].'
                    );
                }
            }
            // Deal with single field
            else {
                appendField(name, val);
            }

        });

        // When all async reader field was loaded, start the ajax.
        return $.when.apply($, promises).then(() => {

            postdata += '--' + boundary + '--\r\n';

            // Wrapping ajax request and send.
            s.data = this.str2Uint8Array(postdata).buffer;
            s.processData = false;
            s.contentType = 'multipart/form-data; boundary=' + boundary;

            return $.ajax(s);

        });
    }
}